export default __webpack_public_path__ + "static/media/thdjbr-logo-vert.e4d87ddf.svg";